export const WrapperPageContainerIdConst = 'giftmio-page-wrapper';
